import { render, staticRenderFns } from "./BrowserPermission.vue?vue&type=template&id=425f271c&scoped=true&"
import script from "./BrowserPermission.vue?vue&type=script&lang=js&"
export * from "./BrowserPermission.vue?vue&type=script&lang=js&"
import style0 from "./BrowserPermission.vue?vue&type=style&index=0&id=425f271c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f271c",
  null
  
)

export default component.exports